import { Reveal } from "@/components/Reveal";

export const About = () => (
  <section id="about" data-testid="about-section" className="relative px-6 md:px-12 lg:px-24 py-28 md:py-48 bg-bone border-y border-charcoal/10 overflow-hidden">
    <div
      aria-hidden="true"
      className="pointer-events-none absolute -left-[15vw] -bottom-[20vw] w-[45vw] h-[45vw] rounded-full blur-[90px] opacity-60"
      style={{ background: "radial-gradient(circle, #e9e2f2 0%, #f5e3e1 55%, transparent 75%)" }}
    />
    <div className="relative grid grid-cols-12 gap-8">
      <Reveal className="col-span-12 md:col-span-3">
        <p className="text-[11px] uppercase tracking-[0.34em] text-charcoal-mute md:sticky md:top-32">
          About —<br />
          The Practice
        </p>
      </Reveal>
      <div className="col-span-12 md:col-span-9">
        <Reveal delay={0.1}>
          <p className="font-serif text-3xl md:text-5xl leading-[1.15] tracking-tight max-w-3xl">
            I build brands the way editors build issues — with a point of view, a ruthless
            eye, and <span className="italic text-chrome">room to breathe.</span>
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="mt-14 md:mt-20 grid md:grid-cols-12 gap-10 md:gap-14 items-start">
            <figure className="md:col-span-5" data-testid="about-founder-figure">
              <img
                src="/brand/danielle-founder.webp"
                alt="Danielle Stephens — Founder and Creative Director of The Danielle Edit"
                loading="lazy"
                className="w-full h-auto border border-charcoal/10"
                data-testid="about-founder-photo"
              />
              <figcaption className="mt-4 text-[11px] uppercase tracking-[0.3em] text-charcoal-mute">
                Danielle Stephens — Founder &amp; Creative Director
              </figcaption>
            </figure>
            <div className="md:col-span-7 space-y-6 text-base md:text-lg text-charcoal-soft leading-relaxed">
              <p>
                I&rsquo;m Danielle Stephens, founder of The Danielle Edit. I come from a family
                of artists, with a father who taught art as both a teacher and professor.
                Creativity was part of my everyday life, and it shaped how I see beauty, tell
                stories, and bring ideas into form.
              </p>
              <p>
                My experience in luxury merchandising taught me to consider the entire
                experience: how something is presented, how it feels, and what people remember.
                With degrees in Entertainment Business and Music Business, I bring
                both creative instinct and business thinking to the brands I develop.
              </p>
              <p>
                My process moves between hand-drawn work, digital graphics, and AI-assisted
                exploration. I follow the idea and choose the tools that help me express it with
                intention. From an original mark to the details of a complete brand world, I want
                your business to feel unmistakably yours.
              </p>
              <p className="font-serif italic text-2xl md:text-3xl leading-snug text-chrome pt-2">
                Bringing your beauty to life through branding.
              </p>
              <img
                src="/brand/dani-signature.webp"
                alt="Dani — signature logo"
                loading="lazy"
                className="pt-6 w-52 md:w-64 h-auto"
                data-testid="about-signature-mark"
              />
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
